/**
 * Client-visible configuration. `envDir` in vite.config.ts is the repo root, so these come from
 * the same `.env` the api reads (docs/CONTRACT.md §3). In production both URLs are empty and the
 * app uses same-origin relative paths.
 */

/** API origin, e.g. `https://olmt-call-api.localhost`. Empty string means same-origin. */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? ''

/** LiveKit signalling base, e.g. `wss://olmt-call-livekit.localhost`. Never append `/rtc`. */
export const LIVEKIT_URL: string = import.meta.env.VITE_LIVEKIT_URL ?? ''

/** 87-char base64url uncompressed P-256 point; mirrors VAPID_PUBLIC_KEY. */
export const VAPID_PUBLIC_KEY: string = import.meta.env.VITE_VAPID_PUBLIC_KEY ?? ''

/**
 * The platform console (`apps/admin`) origin — `https://olmt-call-admin.localhost` in dev,
 * `https://admin.call.olmt.net` in production. `/admin` is the only route this app keeps of it:
 * the page moved out (docs/CONTRACT.md §11), and an old bookmark is redirected here.
 */
export const ADMIN_URL: string = (import.meta.env.VITE_ADMIN_URL || 'https://olmt-call-admin.localhost').replace(
  /\/+$/,
  '',
)
